interface EmissionActor {
  id: string;
  empresaId: string | null;
  roles: string[];
  empresa?: { tipo: string } | null;
}

interface EmissionReport {
  tipo: string;
  status: string;
  rtId: string | null;
  empresaId: string;
  dossieId: string | null;
  pdfUrl?: string | null;
  emitidoEm?: string | Date | null;
}

export function canEmitReclassification(input: {
  report: EmissionReport | null | undefined;
  dossier: { id: string; status: string } | null | undefined;
  profile: EmissionActor | null | undefined;
}): boolean {
  const { report, dossier, profile } = input;
  return !!(
    report && dossier && profile &&
    report.tipo === "reclassificacao" &&
    !["finalizado", "cancelado"].includes(report.status) &&
    !report.pdfUrl && !report.emitidoEm &&
    dossier.id === report.dossieId && dossier.status === "pronto_emissao" &&
    profile.empresa?.tipo === "VISTORIADORA" &&
    profile.empresaId === report.empresaId &&
    profile.id === report.rtId && profile.roles.includes("rt")
  );
}
